import axios from "axios";

export const searchIFSC = (ifsc: string, sessionId: string | null) => {
  return axios
    .post(
      `${process.env.REACT_APP_BASE_URL}business/fetch/ifsc`,
      {
        params: {
          ifsc: `${ifsc}`,
        },
      },
      {
        headers: {
          Authorization: `Bearer ${sessionId}`,
        },
      }
    )
    .then((response) => {
      return response;
    })
    .catch((err) => err);
};
